<template>
	<section>
		<!--工具条-->
		<el-col :span="100" class="toolbar" style="padding-bottom: 0px;">
<!--		<el-col :span="100"  style="padding-bottom: 0px;">-->
			<el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input
              v-model="filters.operator"
              placeholder="输入用户" clearable >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
              v-model="filters.ipaddr"
              placeholder="输入IP地址">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-select
              v-model="filters.type"
              placeholder="请选操作类型">
            <!-- 添加 "全部" 选项 -->
            <el-option
                :key="''"
                :label="'全部'"
                :value="''"
            ></el-option>
            <el-option
                v-for="(label, value) in this.operation_type"
                :key="value"
                :label="label"
                :value="value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 开始时间和结束时间选择框 -->
        <el-date-picker
            v-model="filters.date[0]"
            type="datetime"
            placeholder="选择开始时间"
        style="margin-left: 10px;" ></el-date-picker>
        <el-date-picker
            v-model="filters.date[1]"
        type="datetime"
        placeholder="选择结束时间"
        style="margin-left: 10px;"
        ></el-date-picker>

<!--        &lt;!&ndash; 使用日期范围选择器，带快捷选项 &ndash;&gt;-->
<!--        <el-form-item>-->
<!--        <el-date-picker-->
<!--            v-model="filters.dateRange"-->
<!--            type="datetimerange"-->
<!--            range-separator="至"-->
<!--            start-placeholder="开始日期"-->
<!--            end-placeholder="结束日期"-->
<!--            :shortcuts="shortcuts"-->
<!--            style="margin-left: 10px;">-->
<!--        </el-date-picker>-->
<!--          </el-form-item>-->


<!--          <el-checkbox-->
<!--              v-model="checkboxSelected"-->
<!--              @change="handleUniqueByDayChange">-->
<!--          </el-checkbox>-->
        <span>按天去重</span>
        <el-checkbox v-model="uniqueByDayChecked" >
        </el-checkbox>



				<el-form-item>
					<el-button type="primary" v-on:click="GetActionListInfo">查询</el-button>
				</el-form-item>
      </el-form>

		</el-col>

		<!--列表-->
		<el-table :data="actionInfo" highlight-current-row v-loading="listLoading"   style="width:100%;"  :header-cell-style="{'text-align':'center'}">
			<el-table-column type="index"  width="40"></el-table-column>
      <el-table-column prop="type" label="操作类型" width="150" align="center" sortable :formatter="formatterType"></el-table-column>
      <el-table-column prop="action" label="操作结果" width="150" align="center" sortable :formatter="formatterAction"></el-table-column>
      <el-table-column prop="operator" label="用户名" width="150" align="center" sortable></el-table-column>
      <el-table-column prop="ipaddr" label="IP" width="150" align="center"  sortable></el-table-column>
      <el-table-column prop="date" label="时间" width="150" align="center"  sortable></el-table-column>
<!--      <el-table-column prop="date" label="有效时间" width="100" align="center"  sortable>-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{scope.row.effective_time.substring(0,10)}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="last_login_date" label="登录时间" width="100" align="center"  sortable>-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{scope.row.last_login_date && typeof scope.row.last_login_date === 'string' ? scope.row.last_login_date.substring(0, 10) : ''}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    <el-table-column prop="description" label="说明" min-width="100" align="center"  ></el-table-column>&ndash;&gt;-->


		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
<!--			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
<!--			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="page_size" :total="total" style="float:right;">-->
<!--			</el-pagination>-->

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20,30,50,100, 200, 500, 1000]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next"
          :total="total"
          >
      </el-pagination>
		</el-col>



    <!--详情界面-->
		<el-dialog title="用户详情" v-model="detailFormVisible" :close-on-click-modal="false" >
			<el-form :model="detailForm" label-width="80px" :rules="detailFormRules" ref="detailForm" width="200px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="帐号" prop="order_id">
              <el-input v-model="detailForm.account" auto-complete="off" readonly class="readonly-input"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="手机号">
              <el-input v-model="detailForm.phone_number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

				<el-row>
  					<el-col :span="22">
  						<el-form-item label="用户名">
							<el-input v-model="detailForm.username"></el-input>
						</el-form-item>
  					</el-col>
				</el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="用户类型">
              <el-select v-model="detailForm.type" placeholder="请选择用户类型" @change="handleTypeChange">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="密码">
              <el-input v-model="detailForm.passwd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="有效期">
              <el-date-picker
                  v-model="detailForm.effective_time"
                  type="datetime"
                  placeholder="请选择有效期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="defaultTime">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="说明">
              <el-input type="textarea" v-model="detailForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
			</el-form>


      <div slot="footer" class="dialog-footer"  >
        <el-button type="primary"   @click="saveUser">保存</el-button>

        <el-button   @click.native="detailFormVisible = false">返回</el-button>
			</div>

		</el-dialog>
	</section>


</template>

<script>
import util from "../../common/js/util";
import {
  getUserListPage,
  removeUser,
  batchRemoveUser,
  getOrderInfoListPage,
  getAllType,
  updateOrder,
  getOrderListExcelEx,
  postUpload,
  removeOrder,
  getTodayOrderSnCode,
  getBarcodeList,
  getSalesmanInfoPage,
  GetUserListInfo,
  saveSalesmanInfo,
  saveUserInfo ,
  removeSalesman,
  GetUserListPage, getUserSn, getCustomersInfoSn,GetActionListPage

} from "../../api/api";

import {getLodop} from '../../LodopFuncs'
import {consignmentPrint} from '../../printModel'
import {hasPermission} from '../../premission'
import {dateToString} from '../../common/js/util'
import itemStyle from "echarts/src/model/mixin/itemStyle";

// import fileDownload from "js-file-download";



export default {
  data() {
    return {
      filters: {
        type: "",
        dateRange: [],
        action: "",
        operator: "",
        ipaddr: "",
        unique_by_day: "0",
        date: ["",""],
      },
      checkboxSelected : false ,
      shortcuts: [
        {
          text: '当天',
          onClick(picker) {
            const today = new Date();
            const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '前一天',
          onClick(picker) {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            const start = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0);
            const end = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本周',
          onClick(picker) {
            const today = new Date();
            const dayOfWeek = today.getDay();
            const start = new Date(today);
            start.setDate(today.getDate() - dayOfWeek + 1);
            start.setHours(0, 0, 0, 0);

            const end = new Date(start);
            end.setDate(start.getDate() + 6);
            end.setHours(23, 59, 59, 999);

            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本月',
          onClick(picker) {
            const today = new Date();
            const start = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
            const end = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '近三个月',
          onClick(picker) {
            const today = new Date();
            const start = new Date(today.getFullYear(), today.getMonth() - 2, 1, 0, 0, 0);
            const end = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        }
      ],
      inputKey: 0 , // 初始值
      orderInfo: [],
      page_size: 30,
      statusList:[],
      customs_clearance_typeList:[],
      payment_typeList:[],
      freight_typeList:[],
      total: 0,
      page: 1,
      init_order_id:'',
      order_sn:'',
      barcodeList:'',
      listLoading: false,
      sels: [], //列表选中列

      detailFormVisible: false, //详情界面是否显示
      editLoading: false,
      detailFormRules: {
        name: [{ required: true, message: "请输入运单", trigger: "blur" }]
      },
      //详情界面数据
      detailForm: {
        id : 0,
        phone_number: "",
        type: null,
        account: "",
        username: "",
        passwd: "",
        effective_time: "",
        description: "",
      },
      defaultTime: '00:00:00' ,// 默认时间为 00:00:00
      typeOptions: [
        { value: '', label: '全部' },
        { value: 10, label: '永久' },
        { value: 20, label: '订阅' },
        { value: 30, label: '试用' }
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      creation_date: '',
      value2: ''
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.GetActionListInfo()
    },

    handleSizeChange(val) {
      console.log(val)
      this.page = 1
      this.page_size = val;
      this.GetActionListInfo()
    },
    saveUser(){
      this.detailFormVisible = false;
      console.log('this.detailForm--')
      // this.detailForm.effective_time = this.formatDate(this.detailForm.effective_time)
      if (this.detailForm.effective_time instanceof Date) {
        this.detailForm.effective_time = this.formatDate(this.detailForm.effective_time)
      }
      saveUserInfo(this.detailForm).then(res => {
        this.listLoading = false;
        let msg = res.msg

        this.$message({
            message: msg,
            type: "success"
          });

        this.GetUserListInfo();

      });
    },
    limitMaxvalue(){
      if(this.detailForm.number > 999){
        this.detailForm.number = 1;
        this.$message("件数最多只能输入999");
      }
    },

    typeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case 10:
          return '永久';
        case 20:
          return '订阅';
        case 30:
          return '试用';
        default:
          return '未知'; // 可选：处理未定义的类型
      }
    },

    handleTypeChange(type) {
      //自动配置有效期
      const now = new Date();
      now.setHours(0, 0, 0, 0); // 设置为当天的 00:00:00
      let effectiveTime = '';

      switch (type) {
        case 10: // 永久
          effectiveTime = '9999-12-31 00:00:00';
          break;
        case 20: // 订阅，1 个月后
          now.setMonth(now.getMonth() + 1);
          effectiveTime = this.formatDate(now);
          break;
        case 30: // 试用，1 天后
          now.setDate(now.getDate() + 1);
          effectiveTime = this.formatDate(now);
          break;
        default:
          effectiveTime = ''; // 未选择时为空
      }

      this.detailForm.effective_time = effectiveTime;
      console.log('effectiveTime----',effectiveTime)
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d} 00:00:00`;
    },


    getAllTypeInfo() {
      let para = {};
      this.listLoading = true;
      //NProgress.start();
      getAllType(para).then(res => {
        this.login = res.data.login;
        this.operation_type = res.data.operation_type;
      });
    },

    sourceFormat(val,brandList) {
      // 可以输出看下 val 是什么，方便匹配；
      // :formatter="sourceFormat"    val 就应该是 val.processField
      let branchName = val
      brandList.forEach(item => {
        if(item.key == val) {
          branchName = item.value
          return branchName
        }
      })
      return branchName
    },

    // formatter 函数，映射字段值
    formatterType(row, column, cellValue) {
      if (cellValue === 'system_login') return '后台登录';
      // 使用 operation_type 对象来映射 'login' => '登录'
      return this.operation_type[cellValue] || cellValue;
    },


    // formatter 函数，映射字段值
    formatterAction(row, column, cellValue) {
      // 使用 operation_type 对象来映射 'login' => '登录'
      return this.login[cellValue] || cellValue;
    },


    handleUniqueByDayChange(val) {
      // 当复选框状态改变时调用
      this.filters.unique_by_day = val ? '1' : '0';
    },

// 获取日志列表
    GetActionListInfo() {
      //{"page":1,"pageSize":10,"project_name":null,"app_name":"web-uam.jar","created_by_name":null}
      let creation_date = []
      if (this.filters.creation_date != null){
        if(this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = dateToString(this.filters.creation_date[0]);
          creation_date[1] = dateToString(this.filters.creation_date[1]);
        }
      }
      let para = {
        page: this.page,
        pageSize: this.page_size,
        type: this.filters.type,
        action: this.filters.action,
        operator: this.filters.operator,
        ipaddr: this.filters.ipaddr,
        date: this.filters.date,
        unique_by_day: this.filters.unique_by_day,

      };
      console.log(para);
      this.listLoading = true;
      //NProgress.start();
      GetActionListPage(para).then(res => {

        let code = res.code
        let msg = res.error_detail
        // console.log(code)
        if (code != 0){
          this.$message(msg)
          this.$router.push({ path: '/login' });
        }
        this.total = res.data.pagintion.rowTotal;
        this.page_size = res.data.pagintion.pageSize;
        this.actionInfo = res.data.result;
        this.listLoading = false;
      });
    },


    handleEditStatus: function(index, row) {

      let update_status
      let confirm_msg
      if (row.status == 0){
        update_status = 1;
        confirm_msg =  "确认激活【" +  row.account + "】帐号吗？"
      }else {
        update_status = 0;
        confirm_msg = "确认禁用【" + row.account + "】帐号吗？\n禁用后用户无法再登录"
      }

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      })
          .then(() => {
            this.listLoading = true;
            // console.log(row.order_id)
            //NProgress.start();
            let para = {
              account: row.account ,
              update_status: update_status
            };
            saveUserInfo(para).then(res => {
              this.listLoading = false;
              let code = res.code;
              let msg = res.msg

              if (code != 0) {
                // console.log(msg)
                this.$message({
                  message: msg,
                  type: "warning"
                });
              } else {
                this.$message({
                  message: msg,
                  type: "success"
                });
              }
              this.GetUserListInfo();
            });
          })
          .catch(() => {});
    },

    handleEditReset: function(index, row) {

      let sn
      let confirm_msg

      confirm_msg =  "确认重置【" +  row.account + "】 帐号吗？"

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      })
          .then(() => {
            this.listLoading = true;
            // console.log(row.order_id)
            //NProgress.start();
            let para = {
              account: row.account ,
              update_sn: 'reSet66666666'
            };
            saveUserInfo(para).then(res => {
              this.listLoading = false;
              let code = res.code;
              let msg = res.msg

              if (code != 0) {
                // console.log(msg)
                this.$message({
                  message: msg,
                  type: "warning"
                });
              } else {
                this.$message({
                  message: msg,
                  type: "success"
                });
              }
              this.GetUserListInfo();
            });
          })
          .catch(() => {});
    },





    //删除
    handleDel: function(index, row) {
      let message =  "确认删除帐号【" + row.account + "】吗?"
      this.$confirm(message, "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { account: row.account,
            'enabled_flag' : 0};
            saveUserInfo(para).then(res => {
            this.listLoading = false;
            let code = res.code;
            let msg = res.msg

            if (code != 0) {
              // console.log(msg)
              this.$message({
                message: msg,
                type: "warning"
              });
            } else {
              this.$message({
                message: msg,
                type: "success"
              });
            }
            this.GetUserListInfo();
          });
        })
        .catch(() => {});
    },
    //显示详情界面
    handleEdit: function(index, row) {
      this.detailFormVisible = true;
      this.detailForm = Object.assign({}, row);
    },
    //显示详情界面



    openDetailFormVisible: function() {

      let para = {aa:"bb"}



      getUserSn(para).then(res => {

        let account = res.data.user_sn

        this.resetForm(account);

      });

      this.detailFormVisible = true;
      this.editMark = true;
    },

    openUpload: function() {
      this.upload = true;
    },

    resetForm(account) {
      //初始化表单

        // this.$refs[formName].resetFields();
        this.detailForm = {
          id: 0,
          account: account,
          passwd: "",
          username: "",
          description: "",
        };
    },


    //导出列表
    getOrderListExcel() {
      var ids = this.sels.map(item => item.id).toString()

      let para = { ids: ids };
      // console.log(ids)
      if (ids == ""){
        alert("未选中导出的记录，请选择后再【导出】")
        return  0
      }


      getOrderListExcelEx(para).then(res => {
        this.listLoading = false
      });



    },



    // 上传文件
    onUpload (file) {
      let formData = new FormData()

      formData.append('file',file.file)
      postUpload(formData).then((res) => {
        formData.length = 0
        let count = res.data.data.count
        // console.log(formData)
        let msg =  "成功上传" + count + "条记录。"
        this.$message.success(msg)
        this.getOrderInfo();
        setTimeout(
            ()=>{
              location.reload();
            } , 3000)
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },



      checkHasPermission: function(button_name,view_name) {
      return hasPermission(button_name,view_name);
    },

    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      var ids = this.sels.map(item => item.id).toString();
      this.$confirm("确认删除选中用户吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { ids: ids };
          batchRemoveUser(para).then(res => {
            this.listLoading = false;
            let { msg, code } = res.data;
            if (code !== 200) {
              this.$message({
                message: msg,
                type: "warning"
              });
            } else {
              this.$message({
                message: msg,
                type: "success"
              });
            }
            this.getUsers();
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.GetActionListInfo();
    this.getAllTypeInfo();
  },
  computed: {
    uniqueByDayChecked: {
      get() {
        return this.filters.unique_by_day === '1';
      },
      set(val) {
        this.filters.unique_by_day = val ? '1' : '0';
      }
    }
  }
};
</script>

<style scoped>

</style>

<style>
.readonly-input input {
  background-color: #f0f0f0; /* 设置背景颜色为灰色 */
  color: #999; /* 设置文字颜色为灰色 */
  cursor: not-allowed; /* 设置鼠标样式为禁止符号 */
}

.center {
  position: absolute;
  left: 50%;
  //top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
}

.el-dialog{
  width: 600px;
}

.el-input__clear {
  visibility: visible !important;
}

</style>



// WEBPACK FOOTER //
// logManage.vue?216f7c81